// import School from '@/store/School'
import StrapiService from '@/services/StrapiService'
import { reactive } from 'vue'
import ConfigService from '@/services/ConfigService.js'

export const TOPIC_REWARD = 50

// Reactive cache for quiz stats
const store = reactive({
  stats: null
})

const SchoolService = {
  /**
   * Get all topics
   * @returns {Promise<T[]>}
   */
  getTopics: async () => {
    let { data: topics } = await StrapiService.getContentType('school-topics', {
      populate: {
        'school_topic_pages': {
          fields: ['id', 'original_id', 'title', 'order', 'package_id'],
          sort: 'order:asc'
        }
      },
      sort: 'order:asc'
    })

    return topics ?? []
  },

/*  async getTopic (id) {
    const { data: topic } = await StrapiService.getContentTypeEntry('school-topics', id,{
      populate: {
        'school_topic_pages': {
          sort: ['order:asc'],
          populate: ['header']
        }
      }
    })

    return topic
  },*/

  async getTopicPage (id) {
    const { data: page } = await StrapiService.getContentTypeEntry('school-topic-pages', id, {
      populate: {
        'school_topic': true,
        'sections': {
          populate: {
            'header': true
          }
        },
        'school_questions': {
          populate: {
            'answers': true
          }
        }
      }
    })

    return page
  },

/*  async getNewTopics () {
    const { data: topics } = await StrapiService.getContentType('school-topics/new')

    return topics
  },*/

  async getTopicPagesStats (refresh = false) {
    if (!refresh && store.stats) {
      return store.stats;
    }

    const { data: stats } = await StrapiService.getContentType('school-topic-pages/stats')
    store.stats = stats

    return store.stats
  },

  async addSchoolStylesheet () {
    // Add it once
    const cmsDomain = await ConfigService.getString('cms_url')
    const link = document.createElement('link');
    link.rel = 'stylesheet'
    link.href = `${cmsDomain}/school2.css`
    document.head.appendChild(link)
  },

  // async getNewUnseen () {
  //   // const seenTopics = School.getTopics()
  //   const newTopics = await SchoolService.getNewTopics()
  //   const seenTopics = School.getTopics()
  //
  //   return newTopics.filter(tid => !seenTopics.includes(tid))
  // }
}

export default SchoolService
